import { Any } from "@cede/types";

/**
 * Base error class
 * @param {number} code - Error code
 * @param {string} message - Error message
 * @param {string} description - "A detailed error description, which may be more comprehensive than the error message, can include placeholders.
 * These placeholders are substituted with values from the context.
 * @example
 * throw new BaseError({ code: 3100, message: "Could not find the order", description: "{account.accountName} - {vault.name}: Order not found", });
 */
export class BaseError extends Error {
  code;
  message;
  description;
  userFacingDescription;
  isBaseError = true;
  metadata: Record<string, Any> = {};

  constructor({
    code,
    message,
    description,
    userFacingDescription,
    metadata,
  }: {
    code: number;
    message: string;
    description: string;
    userFacingDescription: string;
    metadata?: Record<string, Any>;
  }) {
    super(message);
    this.code = code;
    this.message = message;
    this.description = description;
    this.userFacingDescription = userFacingDescription;
    this.metadata = metadata || {};
  }
}
